(ns story-builder.interactive-list.db)

(defn defaults []
  {:quiz                {:type     "QUIZ"
                         :name     ""
                         :question ""
                         :config   {:amp {:options [{:text     ""
                                                     :correct? true
                                                     :id       (str (random-uuid))}
                                                    {:text ""
                                                     :id   (str (random-uuid))}]}}}
   :image-quiz          {:type     "IMAGE_QUIZ"
                         :name     ""
                         :question ""
                         :config   {:amp {:options [{:text     ""
                                                     :correct? true
                                                     :id       (str (random-uuid))}
                                                    {:text ""
                                                     :id   (str (random-uuid))}]}}}
   :poll                {:type     "POLL"
                         :name     ""
                         :question ""
                         :config   {:amp {:options [{:text ""
                                                     :id   (str (random-uuid))}
                                                    {:text ""
                                                     :id   (str (random-uuid))}]}}}
   :binary-poll         {:type     "BINARY_POLL"
                         :name     ""
                         :question ""
                         :config   {:amp {:options [{:text ""
                                                     :id   (str (random-uuid))}
                                                    {:text ""
                                                     :id   (str (random-uuid))}]}}}
   :image-poll          {:type     "IMAGE_POLL"
                         :name     ""
                         :question ""
                         :config   {:amp {:options [{:text ""
                                                     :id   (str (random-uuid))}
                                                    {:text ""
                                                     :id   (str (random-uuid))}]}}}
   :interactive-results {:type     "RESULTS"
                         :name     ""
                         :question ""
                         :config   {:amp {:options [{:text ""
                                                     :id   (str (random-uuid))}
                                                    {:text ""
                                                     :id   (str (random-uuid))}]}}}
   :quiz-results        {:type     "QUIZ_RESULTS"
                         :name     ""
                         :question ""
                         :config   {:amp {:options [{:text ""
                                                     :id   (str (random-uuid))}
                                                    {:text ""
                                                     :id   (str (random-uuid))}]}}}
   :poll-results        {:type     "POLL_RESULTS"
                         :name     ""
                         :question ""
                         :config   {:amp {:options [{:text ""
                                                     :id   (str (random-uuid))}
                                                    {:text ""
                                                     :id   (str (random-uuid))}]}}}
   :slider              {:type     "SLIDER"
                         :name     ""
                         :question ""
                         :config   {:amp {:options [{:text ""}]}}}})

(defn initial-values [filters]
  {:interactive-list {:interactive-list/new-interactive          (:quiz (defaults))
                      :interactive-list/emoji-picker-open?       {}
                      :interactive-list/filters                  {:applied filters}
                      :interactive-list/selected-interactive-ids #{}}})
